import {fetch} from "utils/dataAccess";
import {ITEM_PER_PAGE} from "config/_pagination";

export function error(error) {
    return {type: "ROLES_LIST_ERROR", error};
}

export function loading(loading) {
    return {type: "ROLES_LIST_LOADING", loading};
}

export function success(retrieved) {
    return {type: "ROLES_LIST_SUCCESS", retrieved};
}

export function list(params = `order[name]=asc&pagination=true&itemsPerPage=${ITEM_PER_PAGE}&page=1`) {
    const url = "/roles?" + params;

    return dispatch => {
        dispatch(loading(true));
        dispatch(error(""));

        fetch(url)
            .then(response => {
                response.json().then(retrieved => {
                    dispatch(loading(false));
                    dispatch(success(retrieved));
                }).catch(e => {
                    dispatch(loading(false));
                    dispatch(error(e.message));
                })
            }).catch(error => {
                //canceled
            })

    };
}

export function reset() {
    return dispatch => {
        dispatch({type: "ROLES_LIST_RESET"});
    };
}

